export default "__VITE_ASSET__59ebcbf2__"